import {Vehicle} from "./Vehicle";
import {PrimaryDriver} from "./PrimaryDriver";

export class GetQuoteVehicleAndDriverDetails {
  public vehicle: Vehicle = new Vehicle();
  public primaryDriver: PrimaryDriver = new PrimaryDriver();
}
